import { BankAccountActions, BankAccountActionTypes, LoadBankAccountsSuccess } from '../actions/bank-account.actions';
import { SummaryBankAccountModel } from '../../models/summary-bank-account.model';

export interface BankAccountState {
  items: SummaryBankAccountModel[];
  total: number;
  loading: boolean;
  error: any;
}

export const initialState: BankAccountState = {
  items: [],
  total: 0,
  loading: false,
  error: null
};

export function BankAccountReducer(
  state = initialState,
  action: BankAccountActions
): BankAccountState {
  switch (action.type) {
    case BankAccountActionTypes.LoadBankAccounts:
      return { ...state, loading: true, error: null };

    case BankAccountActionTypes.LoadBankAccountsSuccess: {
      const { items, total } = (action as LoadBankAccountsSuccess).payload;
      return { ...state, loading: false, error: null, items, total };
    }

    case BankAccountActionTypes.LoadBankAccountsFailure:
      return { ...state, loading: false, error: (action as any).payload.error };

    default:
      return state;
  }
}
